export default __webpack_public_path__ + "static/media/ls_composition.a0c9efac.jpg";